import { ShieldPlus, UserPlus } from 'lucide-react'

import { CommandProps } from '~/components/command-menu/types'
import { InvitePayeeDialog } from '~/components/compliance/PayeeList'
import { InviteMemberDialogContent } from '~/components/settings/InviteMemberDialogContent'
import { sendTrackingData } from '~/utils/tracking'

export const inviteCommands: CommandProps[] = [
  {
    category: 'invite',
    label: () => 'Invite a workspace member',
    icon: () => <UserPlus />,
    isDisabled: ({ orgMember }) => orgMember?.role !== 'OWNER',
    onSelect: ({ actions: { setGlobalModalState, setActiveView } }) => {
      sendTrackingData('commandMenuItemSelected', {
        category: 'invite',
        item: 'invite_team_member',
      })

      setGlobalModalState({
        isOpen: true,
        content: (
          <InviteMemberDialogContent
            closeDialog={() => {
              setGlobalModalState({ isOpen: false, content: null })
            }}
          />
        ),
      })
      setActiveView(null)
    },
    shortcuts: ['i'],
  },
  {
    category: 'invite',
    label: () => 'Invite a compliant payee',
    icon: () => <ShieldPlus />,
    isDisabled: ({ orgMember, compliance }) =>
      orgMember?.role !== 'OWNER' ||
      !compliance.isVerified ||
      !compliance.canAddRecipients ||
      !compliance.canInvite,
    onSelect: ({ actions: { setGlobalModalState, setActiveView } }) => {
      sendTrackingData('commandMenuItemSelected', {
        category: 'invite',
        item: 'invite_compliant_payee',
      })

      setGlobalModalState({
        isOpen: true,
        content: (
          <InvitePayeeDialog
            onCloseAction={() => {
              setGlobalModalState({ isOpen: false, content: null })
            }}
          />
        ),
      })
      setActiveView(null)
    },
    shortcuts: ['p'],
  },
]
